import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state= {
  arrListingHome: [],
  arrListingMarketPlace: [],
  arrListBanner: [],
  arrListingRealEstate: [],
  arrListingVehicles: [],
  arrListingJobs: [],
  arrListingHotDeals: [],
  hotDeals: null,
};
const getters = {
  arrListingHome(state){
    return state.arrListingHome
  },
  arrListingMarketPlace(state){
    return state.arrListingMarketPlace
  },
  arrListBanner(state){
    return state.arrListBanner
  },
  arrListingRealEstate(state){
    return state.arrListingRealEstate
  },
  arrListingVehicles(state){
    return state.arrListingVehicles
  },
  arrListingJobs(state){
    return state.arrListingJobs
  },
  arrListingHotDeals(state){
    return state.arrListingHotDeals
  },
  hotDeals(state){
    return state.hotDeals
  },
};

const actions = {
  [actionType.GET_LISTING_HOT_DEALS]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      let obj={
        take: params.take,
        page: params.page,
        filter: params.filter,
      }
      if(params.listing_category_id){
        obj.listing_category_id=params.listing_category_id;
      }
      api.get('listings/home', {
        params: obj,
      }).then(result => {
        resolve(result)
      })
    .catch(error => reject(error));
    });
  },
  [actionType.GET_LISTING_HOME]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      let obj={
        take: params.take,
        page: params.page,
        filter: params.filter,
      }
      if(params.listing_category_id){
        obj.listing_category_id=params.listing_category_id;
      }
      api.get('listings/home', {
        params: obj
      }).then(result => {
        commit(mutationType.SET_LIST_CATEGORY_CHILD, {
          hotDeals:result.data.data.hot_deal,
          data: result.data.data.listings,
          type: params.listing_category_id,
          filter: result.data.data.filter
        })
        resolve(true)
      })
    .catch(error => reject(error));
    });
  },
  [actionType.GET_LIST_BANNER]: async function({ commit }, params){
    return new Promise((resolve, reject) => {
      api.get('/banner_types', {
        params: {
          take: params.take,
          page: params.page,
          id: params.type_id
        },
      }).then(result => {
        commit(mutationType.LIST_BANNER, {
          data: result.data.data,
        })
      })
    .catch(error => reject(error));
    });
  },
  [actionType.GET_AFFILIATE_LISTING]:async function({ commit }, params){
    return new Promise((resolve, reject) => {
      api.get('listings/affiliate', {
        params: {
          take: params.take,
          page: params.page,
          id: params.type_id
        },
      }).then(result => {
        resolve(result.data.data)
      })
    .catch(error => reject(error));
    });
  }
};

const mutations = {
  [mutationType.SET_LIST_CATEGORY_CHILD]: function(state, data) {
    if(data.data.length)
    {
      data.data.splice(Math.floor(Math.random() * data.data.length),0,{
          showGoogleAds:true,
          price:null,
          title:null,
          province:{
          name:null
          },
          district:{
            name: null
          },
          url_feature_image: null,
          id: null,
          listing_premiums: []
      })
    }
    
    if(data.type == 1){
      if(data.data.length < 32 && data.filter == "Feature")
      {
        let count = 32 - data.data.length;
        for(let i = 1; i <= count;i++)
        {
          data.data.push(
            {
              isCardFeature:true
            }
          )
        }
        
      }
      state.arrListingMarketPlace = data.data
    }
    else 
      if(data.type == 2){
        if(data.data.length < 32 && data.filter == "Feature")
        {
          let count = 32 - data.data.length;
          for(let i = 1; i <= count;i++)
          {
            data.data.push(
              {
                isCardFeature:true
              }
            )
          }
          
        }
        state.arrListingRealEstate = data.data
      }
    else 
      if(data.type == 3){
        if(data.data.length < 32 && data.filter == "Feature")
        {
          let count = 32 - data.data.length;
          for(let i = 1; i <= count;i++)
          {
            data.data.push(
              {
                isCardFeature:true
              }
            )
          }
          
        }
        state.arrListingVehicles = data.data
      }
    else if(data.type == 32){
      if(data.data.length < 32 && data.filter == "Feature")
      {
        let count = 32 - data.data.length;
        for(let i = 1; i <= count;i++)
        {
          data.data.push(
            {
              isCardFeature:true
            }
          )
        }
        
      }
      state.arrListingJobs = data.data
    }
    else 
    if(data.filter == "HotDeals"){
      if(data.data.length < 32 && data.filter == "HotDeals")
      {
        let count = 32 - data.data.length;
        for(let i = 1; i <= count;i++)
        {
          data.data.push(
            {
              isCardFeature:true
            }
          )
        }
        
      }
      state.arrListingHotDeals = data.data;
      state.hotDeals = data.hotDeals;
    }else {
      if(data.data.length < 40 && data.filter == "Feature")
      {
        let count = 40 - data.data.length;
        for(let i = 1; i <= count;i++)
        {
          data.data.push(
            {
              isCardFeature:true
            }
          )
        }
        
      }
      state.arrListingHome = data.data
    }
  },
  [mutationType.LIST_BANNER]: function(state, data) {
    state.arrListBanner = data.data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}